import React from 'react';
import PropTypes from 'prop-types';

import { compose } from 'redux';
import { connect } from 'react-redux';
import { setFormProperties } from '../../../../../redux/search_area/Actions';

import withStyles from '@material-ui/core/styles/withStyles';

import SimpleHeading from '../SimpleHeading';
import TextField from '../../../../Common/UI/TextField';

class NameDescription extends React.Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        reducerName: PropTypes.string.isRequired,
        reducerFormKey: PropTypes.string.isRequired,
        heading: PropTypes.string,
        // Redux State
        name: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
        // Redux Dispatch
        dispatchSetPlanningAlertFormProperties: PropTypes.func.isRequired
    };

    static defaultProps = {
        heading: 'Provide name and description'
    };

    constructor (props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange (event) {
        this.props.dispatchSetPlanningAlertFormProperties({ [event.target.name]: event.target.value });
    }

    render () {
        const { classes, heading, name, description } =this.props;
        return (
            <div className={classes.root}>
                <SimpleHeading label={heading} />
                <TextField
                    name="name"
                    onChange={this.handleChange}
                    placeholder={'Name'}
                    value={name}
                    fullWidth
                />
                <TextField
                    name="description"
                    multiline
                    rows={2}
                    onChange={this.handleChange}
                    placeholder={'Add an optional description'}
                    value={description}
                    fullWidth
                />
            </div>
        );
    }
}

const style = theme => ({
    root: {
        '&> *:not(:last-child)':{
            marginBottom: theme.constants.verticalMargin
        }
    }
});


const mapStateToProps = (state, ownProps) => {
    const form = state[ownProps.reducerName][ownProps.reducerFormKey];
    return {
        name: form.name,
        description: form.description
    };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
    dispatchSetPlanningAlertFormProperties: (props) => dispatch(setFormProperties(ownProps.reducerName, props))
});

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(style)
)(NameDescription);